<app-attendee-advice-collection
  *ngIf="advices"
  [advices]="advices"
  [description]="section.section_informations.description"
  [title]="section.section_informations.title"
  [seeMore]="section.see_more"
  [link]="seeMorelink"
>
</app-attendee-advice-collection>
